export const IRIS_MARKETING_SLOT_URL = '/content-aggregator/shared-components/zones/s1';
export const STORES_URL = 'stores';
export const IRIS_MARKETING_SLOT_URL_WITH_SEARCH =
    '/content-aggregator/shared-components/zones/s1/s/{searchTerm}?searchTerm={searchTerm}';
export const IRIS_BOPIS_TOOLTIP_MESSAGE = 'cf-holidaybopismsg-gallery';
export const STORE_SERVICES_URL = 'stores/services';
export const ECR_SESSION_ID = 'ecrSessionId';
export const PDP = 'PDP';
export const JSESSION_URL = ';jsessionid=';
